import saMessages from '../locales/pt_BR.json';

const saLang = {
  messages: {
    ...saMessages,
  },
  locale: 'pt-BR',
};
export default saLang;
